import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // check if route is restricted by role      
      if (route.data.panels && route.data.panels.indexOf(currentUser.panel) === -1) {
        // role not authorised so redirect to home page
        this.router.navigate(['/unauthorised']);
        return false;
      }
      if (route.data.routeName && !this.authenticationService.hasPrivilege(route.data.routeName)) {
        this.router.navigate(['/unauthorised']);
        return false;
      }
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
